import type { KpiCard } from '../formatters';

type MonitoringKpiGridProps = {
  cards: KpiCard[];
};

const MonitoringKpiGrid = ({ cards }: MonitoringKpiGridProps) => (
  <section className="realtime-monitoring-tab__section realtime-monitoring-tab__section--summary">
    <h2 className="realtime-monitoring-tab__section-title">Summary</h2>
    <div className="realtime-monitoring-tab__kpis">
      {cards.map(kpi => (
        <div key={kpi.label} className="realtime-monitoring-tab__kpi-card">
          <div className="realtime-monitoring-tab__kpi-label">{kpi.label}</div>
          <div className="realtime-monitoring-tab__kpi-value">{kpi.value}</div>
        </div>
      ))}
    </div>
  </section>
);

export default MonitoringKpiGrid;
